import EventBus from 'app/common/eventbus/EventBus';
import { UnityMessageIncomingEvent } from 'app/common/eventbus/Events';

export class UnityNotificationListener {
    private eventBus: EventBus;
    private handlers = new Map<string, Array<(notification: unknown) => void>>();

    public constructor(eventBus: EventBus) {
        this.eventBus = eventBus;
    }

    public register<T>(type: string, callback: (notification: T) => void) {
        if (!this.handlers.has(type)) {
            this.handlers.set(type, []);

            this.eventBus.register(UnityMessageIncomingEvent.NAME, (event: UnityMessageIncomingEvent) => {
                if ((JSON.parse(event.message) as { type: string }).type === type) {
                    const parsedNotification = JSON.parse(event.message) as T;
                    (this.handlers.get(type) ?? []).forEach(handlerCallback => {
                        handlerCallback(parsedNotification);
                    });
                }
            });
        }

        this.handlers.get(type).push(callback);
    }

    public unregister<T>(type: string, callback: (notification: T) => void) {
        if (this.handlers.has(type)) {
            const callbacks = this.handlers.get(type);
            const index = callbacks.findIndex(x => x === callback);
            if (index !== -1) {
                callbacks.splice(index, 1);
            }
        }
    }

    public unregisterAll(type: string) {
        if (this.handlers.has(type)) {
            this.handlers.set(type, []);
        }
    }
}
